import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "app-logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.$route.meta.ownsHeader)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createVNode(_component_Logo, {
            variant: "desktop",
            color: "brand",
            height: 24
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}